import styled from 'styled-components';

const EmptyHeader = styled.div`
    height: 4.3rem;
`;

export default EmptyHeader;
